/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The DisplayedWordVo model module.
   * @module drill/model/DisplayedWordVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>DisplayedWordVo</code>.
   * @alias module:drill/model/DisplayedWordVo
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>DisplayedWordVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/DisplayedWordVo} obj Optional instance to populate.
   * @return {module:drill/model/DisplayedWordVo} The populated <code>DisplayedWordVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'word')) {
        obj['word'] = ApiClient.convertToType(data['word'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'isPunctuation')) {
        obj['isPunctuation'] = ApiClient.convertToType(data['isPunctuation'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'before')) {
        obj['before'] = ApiClient.convertToType(data['before'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'after')) {
        obj['after'] = ApiClient.convertToType(data['after'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'refBeginIndex')) {
        obj['refBeginIndex'] = ApiClient.convertToType(data['refBeginIndex'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'refEndIndex')) {
        obj['refEndIndex'] = ApiClient.convertToType(data['refEndIndex'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 当前词
   * @member {String} word
   */
  exports.prototype['word'] = undefined;
  /**
   * 是否为标点
   * @member {Boolean} isPunctuation
   */
  exports.prototype['isPunctuation'] = undefined;
  /**
   * 单词前空白字符
   * @member {String} before
   */
  exports.prototype['before'] = undefined;
  /**
   * 单词后空白字符
   * @member {String} after
   */
  exports.prototype['after'] = undefined;
  /**
   * 在打分结果List中的开始下标（含当前）
   * @member {Integer} refBeginIndex
   */
  exports.prototype['refBeginIndex'] = undefined;
  /**
   * 在打分结果List中的结束下标（不含当前）
   * @member {Integer} refEndIndex
   */
  exports.prototype['refEndIndex'] = undefined;



  export default exports;
;


